import { useState } from 'react';
import { Link } from 'react-router-dom';
import { knowledgeApi, type RAGQueryResponse, type SearchResult } from '../../api/knowledge';

export function SemanticSearchPage() {
  const [query, setQuery] = useState('trail runner listing');
  const [results, setResults] = useState<SearchResult[]>([]);
  const [rag, setRag] = useState<RAGQueryResponse | null>(null);
  const [error, setError] = useState('');

  const search = async () => {
    try {
      const r = await knowledgeApi.searchGET(query);
      setResults(r);
    } catch (e) {
      setError(String(e));
    }
  };

  const runRAG = async () => {
    try {
      const r = await knowledgeApi.ragQuery(query);
      setRag(r);
    } catch (e) {
      setError(String(e));
    }
  };

  return (
    <div className="mx-auto max-w-4xl p-6">
      <Link to="/knowledge" className="text-sm text-slate-600 hover:underline dark:text-slate-400">← Knowledge Center</Link>
      <h1 className="mt-2 text-2xl font-semibold">Semantic Search</h1>
      <div className="mt-6 flex flex-wrap gap-3">
        <input value={query} onChange={(e) => setQuery(e.target.value)}
          className="flex-1 rounded border px-3 py-2 dark:border-slate-600 dark:bg-slate-900" />
        <button onClick={() => void search()} className="rounded bg-slate-900 px-4 py-2 text-white dark:bg-slate-100 dark:text-slate-900">Search</button>
        <button onClick={() => void runRAG()} className="rounded border px-4 py-2 dark:border-slate-600">RAG Query</button>
      </div>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      {rag && (
        <div className="mt-6 rounded-lg border p-4 dark:border-slate-700">
          <h2 className="font-medium">RAG Answer</h2>
          <pre className="mt-2 whitespace-pre-wrap text-sm">{rag.answer}</pre>
          <p className="mt-2 text-xs text-slate-500">Confidence: {(rag.confidence * 100).toFixed(0)}% · Grounded: {rag.grounded ? 'Yes' : 'No'}</p>
        </div>
      )}
      <ul className="mt-6 space-y-2">
        {results.map((r) => (
          <li key={r.id} className="rounded-lg border p-3 text-sm dark:border-slate-700">
            <div className="flex justify-between">
              <span className="font-medium">{r.title}</span>
              <span className="text-indigo-600">{(r.score * 100).toFixed(0)}%</span>
            </div>
            <p className="mt-1 text-slate-600 dark:text-slate-400">{r.snippet}</p>
          </li>
        ))}
      </ul>
    </div>
  );
}
